import PropTypes from 'prop-types';
import { useContext } from 'react';
import { GroupsContext } from '@context/GroupsContext';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getMeUid } from '@api/selectors/auth';
import ScoreboardItems from './ScoreboardItems';

const GroupsScoreboardCard = ({ type, showAvatar, showTrophy }) => {
  const groupsContext = useContext(GroupsContext);
  const { scoreboardData, meUserRank } = groupsContext;
  const currentUserId = useMyInfo(getMeUid);

  const currentUser = scoreboardData.find((user) => user.uid === currentUserId);
  const topThreeUsers = scoreboardData.slice(0, 3);

  const widgetScoreboardData =
    meUserRank < 4 ? topThreeUsers : [...topThreeUsers, currentUser];
  const filteredScoreboard =
    type === 'widget' ? widgetScoreboardData : scoreboardData;

  return (
    <ScoreboardItems
      data={filteredScoreboard}
      showAvatar={showAvatar}
      showTrophy={showTrophy}
      type={type}
      currentUserId={currentUserId}
    />
  );
};

export default GroupsScoreboardCard;

GroupsScoreboardCard.propTypes = {
  type: PropTypes.string.isRequired,
  showAvatar: PropTypes.bool,
  showTrophy: PropTypes.bool
};

GroupsScoreboardCard.defaultProps = {
  showAvatar: false,
  showTrophy: false
};
